
import { Permission, Company } from "./types";

// Key for localStorage
export const PERMISSIONS_STORAGE_KEY = 'rolePermissions';

// Helper to generate defaults for a specific company
const generateCompanyDefaults = (company: Company, minimal: boolean): Permission[] => [
  // Medewerker rol
  { id: `${company}-1`, role: "medewerker", resource: "dashboard", company, read: true, write: false, delete: false },
  { id: `${company}-2`, role: "medewerker", resource: "orders", company, read: !minimal, write: false, delete: false },
  { id: `${company}-3`, role: "medewerker", resource: "inventory", company, read: false, write: false, delete: false },
  { id: `${company}-5`, role: "medewerker", resource: "notifications", company, read: !minimal, write: false, delete: false },
  { id: `${company}-6`, role: "medewerker", resource: "reports", company, read: false, write: false, delete: false },
  { id: `${company}-7`, role: "medewerker", resource: "medewerkers", company, read: false, write: false, delete: false },
  { id: `${company}-22`, role: "medewerker", resource: "feedback", company, read: !minimal, write: !minimal, delete: false },
  { id: `${company}-25`, role: "medewerker", resource: "packagePickup", company, read: !minimal, write: false, delete: false },
  
  // Planner rol
  { id: `${company}-8`, role: "planner", resource: "dashboard", company, read: true, write: !minimal, delete: false },
  { id: `${company}-9`, role: "planner", resource: "orders", company, read: !minimal, write: !minimal, delete: !minimal },
  { id: `${company}-10`, role: "planner", resource: "inventory", company, read: !minimal, write: !minimal, delete: !minimal },
  { id: `${company}-12`, role: "planner", resource: "notifications", company, read: !minimal, write: !minimal, delete: !minimal },
  { id: `${company}-13`, role: "planner", resource: "reports", company, read: !minimal, write: !minimal, delete: false },
  { id: `${company}-14`, role: "planner", resource: "medewerkers", company, read: false, write: false, delete: false },
  { id: `${company}-23`, role: "planner", resource: "feedback", company, read: !minimal, write: !minimal, delete: false },
  { id: `${company}-26`, role: "planner", resource: "packagePickup", company, read: !minimal, write: !minimal, delete: false },
  
  // Management rol - full access
  { id: `${company}-15`, role: "management", resource: "dashboard", company, read: true, write: true, delete: true },
  { id: `${company}-16`, role: "management", resource: "orders", company, read: true, write: true, delete: true },
  { id: `${company}-17`, role: "management", resource: "inventory", company, read: true, write: true, delete: true },
  { id: `${company}-19`, role: "management", resource: "notifications", company, read: true, write: true, delete: true },
  { id: `${company}-20`, role: "management", resource: "reports", company, read: true, write: true, delete: true },
  { id: `${company}-21`, role: "management", resource: "medewerkers", company, read: true, write: true, delete: true },
  { id: `${company}-24`, role: "management", resource: "feedback", company, read: true, write: true, delete: true },
  { id: `${company}-27`, role: "management", resource: "packagePickup", company, read: true, write: true, delete: true },
];

// Default permissions configuration
export const defaultPermissions: Permission[] = [
  ...generateCompanyDefaults("luijten_vvz", false),
  ...generateCompanyDefaults("decoprof", true),
];
